export default "__VITE_ASSET__Bl31Bpc5__"